export const getPartnerAPIKey = (): string => {
  return localStorage.getItem('@doris:partner_apikey') || ''
}
